import React, { useEffect, useRef, useState } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { useStyles } from './ImageViewer.styles';
import theme from '../../../../styles/theme';

interface ImageViewerProps {
  src: string;
  alt: string;
  zoomValue: number;
  onClick?: () => void;
}

interface ImageStyles {
  height?: number;
  width?: number;
  maxHeight?: string;
  maxWidth?: string;
}

export default function ImageViewer({
  src,
  alt,
  zoomValue,
  onClick = () => {},
}: ImageViewerProps) {
  const imageRef = useRef<HTMLImageElement | null>(null);
  const [imageStyles, setImageStyles] = useState<ImageStyles>({});
  const [defaultImageStyle, setDefaultImageStyle] = useState<{
    height: number;
    width: number;
  } | null>(null);
  const { classes } = useStyles(theme);

  useEffect(() => {
    setDefaultImageStyle(null);

    setTimeout(() => {
      if (imageRef.current) {
        setDefaultImageStyle({
          height: imageRef.current.offsetHeight,
          width: imageRef.current.offsetWidth,
        });
      }
    }, 0);
  }, [src]);

  useEffect(() => {
    if (!defaultImageStyle || zoomValue === 1) {
      setImageStyles({});
    } else {
      setImageStyles({
        height: defaultImageStyle.height * zoomValue,
        width: defaultImageStyle.width * zoomValue,
        maxHeight: `${100 * zoomValue}%`,
        maxWidth: `${100 * zoomValue}%`,
      });
    }
  }, [zoomValue, defaultImageStyle]);

  return (
    <div className={classes.imageViewerWrapper} onClick={onClick}>
      <ScrollContainer className={classes.imageContainer}>
        <img
          src={src}
          alt={alt}
          ref={imageRef}
          style={imageStyles}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        />
      </ScrollContainer>
    </div>
  );
}
